import { IFollowUpSurveyCounts } from '@nkr/models/index';
import { Nav } from 'react-bootstrap';
import { NavItemWrapper, NavWrapper } from '../styles';

interface IProps {
    counts: IFollowUpSurveyCounts,
    activeKey: string,
    isAdmin: boolean,
    isNkrLogin: boolean,
    centerId: number
}

const SurveyNav = (props: IProps) => {
    const hrefPrefix = !props.isAdmin ? `/center/${props.centerId}/follow-up/surveys` : `/admin/follow-up/surveys`;

    return (
        <NavWrapper>
            <div style={{ padding: 20, backgroundColor: 'white' }}>
                <Nav bsStyle='pills' className='ms-pills'>
                    <NavItemWrapper active={props.activeKey == 'QUICK-TO-DO'} href={hrefPrefix + '/quick-to-do'}>
                        Quick<br />To-Do <span className='type-count'>({props.counts.allToDo})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'PENDING-ALL'} href={hrefPrefix + '/pending-all'}>
                        All<br />Pending <span className='type-count'>({props.counts.allPending})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'PENDING-SURVEY'} href={hrefPrefix + '/pending-survey'}>
                        Pending<br />Survey <span className='type-count'>({props.counts.pendingSurvey})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'PENDING-REVIEW'} href={hrefPrefix + '/pending-review'}>
                        Pending<br />Review <span className='type-count'>({props.counts.pendingReview})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'PENDING-APPOINTMENT'} href={hrefPrefix + '/pending-appointment'}>
                        Pending<br />Appointment <span className='type-count'>({props.counts.pendingAppointment})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'PENDING-LAB-ORDER'} href={hrefPrefix + '/pending-lab-order'}>
                        Pending<br />Lab Order <span className='type-count'>({props.counts.pendingLabOrder})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'PENDING-LAB-RESULTS'} href={hrefPrefix + '/pending-lab-results'}>
                        Pending<br />Lab Results <span className='type-count'>({props.counts.pendingLabResults})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'COMPLETE-NO-RESULTS'} href={hrefPrefix + '/complete-no-results'}>
                        Complete<br />No Results <span className='type-count'>({props.counts.completeNoResults})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'PENDING-NOTIFY-DONOR'} href={hrefPrefix + '/pending-notify-donor'}>
                        Pending<br />Notify Donor <span className='type-count'>({props.counts.pendingNotifyDonor})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'COMPLETE'} href={hrefPrefix + '/complete'}>
                        Complete <span className='type-count'>({props.counts.complete})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'INCOMPLETE'} href={hrefPrefix + '/incomplete'}>
                        Incomplete <span className='type-count'>({props.counts.incomplete})</span>
                    </NavItemWrapper>

                    <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                    <NavItemWrapper active={props.activeKey == 'ALL'} href={hrefPrefix + '/all'}>
                        All <span className='type-count'>({props.counts.all})</span>
                    </NavItemWrapper>
                </Nav>
            </div>
        </NavWrapper>
    );
}

export default SurveyNav;